import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import * as vars from '../../constants/constants';
import { messages} from '../../constants/messages';
import { show, hide } from '../../actions/ActivityIndicatorActions';
import { getVideoOrChannelRelatedData } from '../../actions/PlayActions';
import { addFavoriteChannel, addFavoriteVideo } from '../../actions/FavoriteActions';
import { showMessage } from '../../actions/FlashMessageActions';
import { console_log } from '../../utils/helper';
import { setHeaderTitle } from '../../actions/HeaderActions';
import { FormattedMessage } from 'react-intl';
import { config } from '../../constants/domainConfig';



class ChannelList extends Component {
	constructor(props) {
	    super(props);

	    this.state = {
	        channels: [],
            videos: [],
            type: '',
            pageId: 0,
            categoryName: "",
            switchToFavourite: false
        };

        this.goToPlay = this.goToPlay.bind(this);
        this.channelFavorite = this.channelFavorite.bind(this);
        this.isChannelFavorite = this.isChannelFavorite.bind(this);
        this.videoFavorite = this.videoFavorite.bind(this);
        this.isVideoFavorite = this.isVideoFavorite.bind(this);
        this.showFavorite = this.showFavorite.bind(this);
    }

    componentWillMount() {
        let pageId = parseInt(this.props.history.location.pathname.split('/')[2]);

        if (this.props.history.location.pathname.split('/')[1] == 'channels') {
            let channelsByCategory = this.props.category.channels.filter((channel) => {
                let catArr = channel.channelCategories.map((cat) => {return cat.categoryId});
                if (~catArr.indexOf(pageId)) {
                    return channel;
                }
            }),
                category = this.props.category.categories.find((c) => {
                    return c.categoryId == pageId;
                });

            this.setState({
                channels: channelsByCategory,
                type: 'channels',
                pageId: pageId,
                categoryName: category.name
            });
        } else {
            let videoByCategory = this.props.category.videos.find((v) => v.id == pageId)['videos'],
                category = this.props.category.videos.find((v) => v.id == pageId);

            this.setState({
                videos: videoByCategory,
                type: 'videos',
                pageId: pageId,
                categoryName: category.name
            });
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.setHeaderTitle('');

    }

    goToPlay(data, event) {
        event.preventDefault();
        if (event.target.tagName == 'path' || event.target.classList.contains('favoriteClick')) {
            if (data.channel) {
                this.channelFavorite(data);
            } else {
                this.videoFavorite(data.video);
            }
        } else {
            this.props.getVideoOrChannelRelatedData(data);
            if (data.channel) {
                this.props.history.push('/play/channel');
            } else {
                this.props.history.push('/play/video');
            }
        }
    }

    channelFavorite(data) {
        let favoriteChannels = this.props.favorite.channels;
        let indexOf = favoriteChannels.findIndex((f) => {
            return f.channelId == data.channel.channelId;
        });
        let channelToBeUpdated = {
            channelId: data.channel.channelId,
            channelName: data.channel.channelName,
            channelLang: data.channel.channelLang,
            channelImage: data.channel.channelImage,
            channelLogo: data.channel.channelLogo,
            channelGrade: data.channel.channelGrade,
            channelStatus: data.channel.channelStatus,
            channelBaseline: data.channel.channelBaseline,
            channelCategories: data.channel.channelCategories,
            isFavorite: true
        };

        if (indexOf == -1) {
            favoriteChannels.push(channelToBeUpdated);
            axios.post(vars.BASE_API_URL+"/favorites/channels", channelToBeUpdated)
                .then((response) => {
                    this.props.showMessage({
                        message: messages[config.lang].addToFavorites,
                        type: true
                    });
                    console_log(response);
                })
                .catch((error) => {
                    console_log(error);
                });
        } else {
            favoriteChannels.splice(indexOf, 1);
            axios.delete(vars.BASE_API_URL+"/favorites/channels/"+channelToBeUpdated.channelId)
                .then((response) => {
                    this.props.showMessage({
                        message: messages[config.lang].removeFromFavorites,
                        type: false
                    });
                    console_log(response);
                })
                .catch((error) => {
                    console_log(error);
                });
        }

        this.props.addFavoriteChannel(favoriteChannels);
    }

    videoFavorite(data) {
        let favoriteVideos = this.props.favorite.videos;
        let indexOf = favoriteVideos.findIndex((f) => {
            return f.videoId == data.id;
        });
        let videoToBeUpdated = {
            videoId: data.id,
            duration: data.duration,
            name: data.name,
            preview: data.preview
        };

        if (indexOf == -1) {
            favoriteVideos.push(videoToBeUpdated);
            axios.post(vars.BASE_API_URL+"/favorites/videos", videoToBeUpdated)
                .then((response) => {
                    this.props.showMessage({
                        message: messages[config.lang].addToFavorites,
                        type: true
                    });
                    console_log(response);
                })
                .catch((error) => {
                    console_log(error);
                });
        } else {
            favoriteVideos.splice(indexOf, 1);
            axios.delete(vars.BASE_API_URL+"/favorites/videos/"+videoToBeUpdated.videoId)
                .then((response) => {
                    this.props.showMessage({
                        message: messages[config.lang].removeFromFavorites,
                        type: false
                    });
                    console_log(response);
                })
                .catch((error) => {
                    console_log(error);
                });
        }

        this.props.addFavoriteVideo(favoriteVideos);
    }

    isChannelFavorite(channelId) {
        let indexOf = this.props.favorite.channels.findIndex((f) => {
            return f.channelId == channelId;
        });

        if (indexOf != -1) {
            return true;
        }
        return false;
    }

    isVideoFavorite(videoId) {
        let indexOf = this.props.favorite.videos.findIndex((f) => {
            return f.videoId == videoId;
        });

        if (indexOf != -1) {
            return true;
        }
        return false;
    }

    showFavorite() {
        this.setState({
            switchToFavourite: !this.state.switchToFavourite
        })
    }

	render() {
		const heartIcon = '<svg class="favoriteClick" xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewbox="0 0 70 70" preserveAspectRatio="none"><path d="M66.43 20.39c-.93-10.37-8.21-17.9-17.32-17.9a17.224 17.224 0 0 0-14.76 8.57 16.588 16.588 0 0 0-14.4-8.57c-9.11 0-16.39 7.52-17.33 17.9a18.807 18.807 0 0 0 .55 6.8 29.14 29.14 0 0 0 8.86 14.91l22.31 20.41L57.02 42.1a29.227 29.227 0 0 0 8.87-14.91 18.412 18.412 0 0 0 .54-6.8z" data-name="fave ico" class="heart-fill"/></svg>';

		let favoriteChannelIds = this.props.favorite.channels.map(m => m.channelId);
		let favoriteVideoIds = this.props.favorite.videos.map(v => v.videoId);
		let thisCategoryChannels = (!this.state.switchToFavourite)? this.state.channels: this.state.channels.filter((channel) => {
		    if (~favoriteChannelIds.indexOf(channel.channelId)) {
		        return channel;
            }
        });
		let thisCategoryVideos = (!this.state.switchToFavourite)? this.state.videos : this.state.videos.filter((video) => {
		    if (~favoriteVideoIds.indexOf(video.id)) {
		        return video;
            }
        });


		return (
			<section className="channel-list py-0">
                <div className="category-head">
                    <h3 className="channel-title">{this.state.categoryName}</h3>
                    <div className="category-head__favorite">
                        <h3>Favorite</h3>
                        <label className="switch">
                            <input type="checkbox" className="switch__checkbox" checked={this.state.switchToFavourite} onChange={this.showFavorite}/>
                            <span className="switch__slider round"></span>
                        </label>
                    </div>
                </div>
                {this.state.type == 'channels'?
                    <div className="channel-list-row grid-list-row">
                        {thisCategoryChannels.length > 0 ?
                            thisCategoryChannels.map((channel) => {
                                return (
                                    <div key={channel.channelId} className="grid-list-col">
                                        <div onClick={this.goToPlay.bind(this, {channel: channel})}>
                                            <div className="channels-thumb channels-thumb--genre channels-thumb--channel-list">
                                                <div className="channels-image channels-image--genre no-radius">
                                                    <img className="channels-thumb__image channels-thumb__image--genre rounded-0" src={channel.channelImage ? vars.BASE_URL+"uploads/"+channel.channelImage : "./img/thumbnail-2.jpg"} alt={channel.channelName}/>
                                                    <img className="channels-thumb__icon" src={channel.channelLogo} alt={channel.channelName} />
                                                </div>
                                                <div className="channels-thumb__details">
                                                    <div className="channels-thumb__fav">
                                                        <input className="icon-toggle favoriteClick" id={'tv-'+channel.channelId} type="checkbox" checked={this.isChannelFavorite(channel.channelId)} onChange={() => {console_log("favorite Changed")}} />
                                                        <label className="icon-toggle-label favoriteClick" htmlFor={'tv-'+channel.channelId}>
                                                            <span className="favoriteClick"><i className="fa fa-star favoriteClick" aria-hidden="true"></i></span>
                                                        </label>
                                                    </div>
                                                    <div className="channels-thumb__inner">
                                                        <div className="channels-thumb__name">
                                                            {channel.channelName}
                                                        </div>
                                                        <div className="channels-thumb__extra">
                                                            <span className="channels-thumb__status"><i className="fa fa-feed" aria-hidden="true"></i>
                                                                <FormattedMessage id="liveNow"
                                                                    defaultMessage="Live Now"
                                                                />
                                                            </span>
                                                            {/*<span className="channels-thumb__views">{((Math.random() * 2) + 1).toFixed(1)}M Viewing</span>*/}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                            : <div className="blank-text"><p>No channels found.</p></div> }
                    </div>
                :   <div className="channel-list-row grid-list-row">
                        {thisCategoryVideos.length > 0 ?
                            thisCategoryVideos.map((v, k) => {
                                return (
                                    <div key={v.id} className="grid-list-col">
                                        <div onClick={this.goToPlay.bind(this, {video: v})}>
                                            <div className="channels-thumb channels-thumb--genre channels-thumb--channel-list">
                                                <div className="channels-image channels-image--genre no-radius">
                                                    <img className="channels-thumb__image channels-thumb__image--genre rounded-0" src={v.preview} alt={v.name} />
                                                </div>
                                                <div className="channels-thumb__details">
                                                    <div className="channels-thumb__fav">
                                                        <input className="icon-toggle favoriteClick" id={'vod-'+v.id} type="checkbox" checked={this.isVideoFavorite(v.id)} onChange={() => {console_log("favorite Changed")}} />
                                                        <label className="icon-toggle-label favoriteClick" htmlFor={'vod-'+v.id}>
                                                            <span className="favoriteClick"><i className="fa fa-star favoriteClick" aria-hidden="true"></i></span>
                                                        </label>
                                                    </div>
                                                    <div className="channels-thumb__inner">
                                                        <div className="channels-thumb__name">
                                                            {v.name}
                                                        </div>
                                                        <div className="channels-thumb__extra">
                                                            <span className="channels-thumb__time">1h 40m</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        : <div className="blank-text"><p>
                                <FormattedMessage id="noVidsFound"
                                    defaultMessage="No Videos found."
                                />
                            </p></div>}
                    </div>
                }
			</section>
		)
	}
}


const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        getVideoOrChannelRelatedData,
        addFavoriteChannel,
        addFavoriteVideo,
        showMessage,
        setHeaderTitle
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ChannelList);


// WEBPACK FOOTER //
// ./src/components/ChannelList/ChannelList.js